import React from 'react'

export const EmptySpan = () => <span style={{ opacity: 0, userSelect: 'none' }}>nodata</span>
